<!--suppress XmlDuplicatedId -->
<template>
  <section class="4862">
    <fab
      v-if="showFloatingActionButton"
      :actions="fabActions"
      :fixed-tooltip="true"
      icon-size="small"
      bg-color="#ff5a5f"
      @object="newObject"
      @ticket="newTicket" />
    <send-mail-modal
      v-if="isAuthenticated"
      :ref="'ref-send-mail-modal'" />
    <message-details-modal
      v-if="isAuthenticated"
      :ref="'ref-message-details-modal'" />
    <modal-send-mail-type
      v-if="isAuthenticated"
      :ref="'ref-modal-send-mail-type'" />
    <b-modal
      :id="'draft-writing-email-modal'"
      ref="draft-writing-email-modal"
      size="md"
      no-close-on-backdrop
      hide-footer
      :title="$t('message.marketingMessages.draftWrintingEmail.title')">
      <div class="col p-0">
        <p>{{ $t('message.marketingMessages.draftWrintingEmail.text') }}</p>
      </div>
      <div class="col p-0">
        <coozzy-button
          size="small"
          class="mb-0 border"
          design="transparent"
          @click="discradDraft()">
          {{ $t('message.marketingMessages.draftWrintingEmail.discard') }}
        </coozzy-button>
        <coozzy-button
          size="small"
          class="float-right mb-0"
          design="green"
          @click="continueEditing()">
          {{ $t('message.marketingMessages.draftWrintingEmail.continueEditing') }}
        </coozzy-button>
      </div>
    </b-modal>
    <vue-cookie-law
      data-cy="cookie-consent-banner"
      :button-text="$t('message.cookie.gotIt')"
      :message="$t('message.cookie.message')" />

    <!-- Sidebar menu -->
    <div
      v-if="isAuthenticated"
      id="app"
      class="app"
      :class="[hasAccessUserBase ? 'with-footer' : '']">
      <coozzy-header />

      <div class="app-body">
        <app-sidebar
          v-if="!hideNavigation()"
          fixed
          class="app-sidebar">
          <coozzy-sidebar-nav
            ref="coozzy-header"
            @close-sidebar="handleCloseSidebar" />
        </app-sidebar>
        <main
          class="main"
          :class="mainSendMailDockClass">
          <div class="container-fluid mt-3">
            <router-view ref="router-view" />
          </div>
        </main>
      </div>
    </div>

    <!-- menu -->
    <div
      v-else
      id="app"
      class="app application_form"
      :class="[ ['ApplicationFormLandingPage', 'AddViewingAppointmentsPage', 'SelectViewingAppointmentsPage', 'DigitalReferenceLandlordPage', 'DigitalReferenceEmployerPage'].includes(currentRouteName) ? 'with-footer' : '']">
      <coozzy-header
        ref="top-header" />
      <router-view />
    </div>
    <coozzy-userbase-footer v-if="hasAccessUserBase || [ 'ApplicationFormLandingPage', 'AddViewingAppointmentsPage', 'SelectViewingAppointmentsPage', 'DigitalReferenceLandlordPage', 'DigitalReferenceEmployerPage'].includes(currentRouteName)" />
    <b-modal
      id="globalConfirmationModal"
      ref="globalConfirmationModal"
      data-cy="global-confirmation-modal"
      no-close-on-backdrop
      :title="$t('message.onBoardingTabs.confirmModal.confirmationTitle')"
      hide-footer>
      <p>{{ $t('message.onBoardingTabs.confirmModal.confirmationText') }}</p>
      <div class="col">
        <coozzy-button
          size="small"
          class="border mb-0"
          data-cy="global-confirmation-cancel-button"
          design="transparent"
          @click="$bvModal.hide('globalConfirmationModal')">
          {{ $t('message.generic.cancel') }}
        </coozzy-button>
        <coozzy-button
          size="small"
          class="float-right mb-0"
          data-cy="global-confirmation-discard-button"
          design="green"
          @click="closeCurrentModal">
          {{ $t('message.onBoardingTabs.confirmModal.confirmationButton') }}
        </coozzy-button>
      </div>
    </b-modal>
    <b-modal
      id="incompatibleBrowserModal"
      ref="incompatibleBrowserModal"
      no-close-on-backdrop
      :title="$t('message.generic.browserSupport.title')"
      hide-footer>
      <p>{{ $t('message.generic.browserSupport.textBody') }}</p>
      <div class="col">
        <coozzy-button
          size="small"
          class="border mb-0"
          design="transparent"
          @click="$bvModal.hide('incompatibleBrowserModal')">
          {{ $t('message.generic.cancel') }}
        </coozzy-button>
        <coozzy-button
          size="small"
          class="float-right mb-0"
          design="green"
          @click="$bvModal.hide('incompatibleBrowserModal')">
          {{ $t('message.onBoardingTabs.confirmModal.confirmationTitle') }}
        </coozzy-button>
      </div>
    </b-modal>
  </section>
</template>

<script>
import * as Sentry from '@sentry/browser'
import { Sidebar as AppSidebar } from '@coreui/vue'
import CoozzySidebarNav from './navigation/CoozzySidebarNav'
import VueCookieLaw from 'vue-cookie-law'
import { hideNavigation } from './mixins/hideNavigation'
import CoozzyHeader from './framework/layout/CoozzyHeader'
import CoozzyUserbaseFooter from './framework/layout/CoozzyUserbaseFooter'
import { user } from './mixins/user'
import { contract } from './mixins/contract'
import fab from 'vue-fab'
import SendMailModal from '@/contact/components/SendMailModal'
import ModalSendMailType from '@/contact/components/ModalSendMailType'
import MessageDetailsModal from './contact/components/MessageDetailsModal.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton'
import router from '@/router/router'
import UserApi from '@/misc/apis/UserApi'

export default {
  components: {
    CoozzyButton,
    SendMailModal,
    MessageDetailsModal,
    ModalSendMailType,
    CoozzyHeader,
    CoozzyUserbaseFooter,
    CoozzySidebarNav,
    VueCookieLaw,
    AppSidebar,
    fab
  },
  mixins: [user, hideNavigation, contract],
  metaInfo: {
    title: '',
    titleTemplate: function (titleChunk) {
      let moduleName
      if (this.$route.path.startsWith('/owner')) {
        moduleName = 'OWNERbase'
      } else if (this.$route.path.startsWith('/admin')) {
        moduleName = 'ADMINbase'
      } else if (this.$route.path.startsWith('/marketing')) {
        moduleName = 'MARKETbase'
      } else if (this.$route.path.startsWith('/asset')) {
        moduleName = 'ASSETbase'
      } else if (this.$route.path.startsWith('/accounting')) {
        moduleName = 'FINANCEbase'
      } else if (this.$route.path.startsWith('/user') || this.$route.path.startsWith('/object/')) {
        moduleName = 'USERbase'
      } else if (this.$route.path.startsWith('/platform')) {
        moduleName = 'Intern'
      } else {
        moduleName = 'PROPbase'
      }

      if (titleChunk) {
        return `${titleChunk} | ${moduleName}`
      } else {
        return moduleName
      }
    }
  },
  data() {
    return {
      minimizedModals: [],
      isComposing: false,
      fabActions: [
        {
          name: 'object',
          icon: 'home',
          tooltip: ''
        },
        {
          name: 'ticket',
          icon: 'assignment',
          tooltip: ''
        },
        {
          name: 'contact',
          icon: 'account_box',
          tooltip: ''
        }
      ],
      userLoginInterval: null,
      currentModal: null
    }
  },
  computed: {
    mainSendMailDockClass() {
      const mode = this.$store.getters['user/sendMailModalDockMode']
      return {
        'main--send-mail-dock-minus': mode === 'minus',
        'main--send-mail-dock-minimized': mode === 'minimized'
      }
    },
    showFloatingActionButton() {
      return this.isAuthenticated &&
        [
          'OwnerOnboardingView'
        ].findIndex(r => this.$route.path.startsWith(r) !== -1)
    },
    currentRouteName() {
      return this.$route.name
    }
  },
  watch: {
    $route() {
      const onboardingListRoute = ['OwnerOnboardingView', 'OnboardingView', 'AdminOnboardingView', 'AssetOnboardingView', 'AccountingOnboardingView', 'OwnerBuildingDetailsView', 'AdminBuildingDetailsView', 'AssetBuildingDetailsView', 'AccountingBuildingDetailsView']
      if (!onboardingListRoute.includes(this.$route.name)) {
        localStorage.removeItem('openCollapse')
      }
      const propertyListRoute = ['PropertyEditingView', 'PropertyDetailsView']
      if (!propertyListRoute.includes(this.$route.name)) {
        localStorage.removeItem('openCollapseProperty')
      }
      if (!propertyListRoute.includes(this.$route.name) && !onboardingListRoute.includes(this.$route.name)) {
        localStorage.removeItem('scrollpos')
      }
      let noAccess = false
      if (this.$route.path.startsWith('/marketing') && !this.hasAccessMarketBase) {
        noAccess = true
      } else if (this.$route.path.startsWith('/owner') && !this.hasAccessPropBase) {
        noAccess = true
      } else if (this.$route.path.startsWith('/accounting') && !this.hasAccessAccountingBase) {
        noAccess = true
      } else if (this.$route.path.startsWith('/admin') && !this.hasAccessAdminBase) {
        noAccess = true
      } else if (this.$route.path.startsWith('/user') && !this.hasAccessUserBase) {
        noAccess = true
      } else if (this.$route.path.startsWith('/asset') && !this.hasAccessAssetBase) {
        noAccess = true
      }

      if (noAccess) {
        if (this.hasAccessPropBase) {
          this.$router.push({ name: 'OwnerDashboardOverview' })
        } else if (this.hasAccessAccountingBase) {
          this.$router.push({ name: 'AccountingDashboardView' })
        } else if (this.hasAccessAdminBase) {
          this.$router.push({ name: 'AdminDashboardView' })
        } else if (this.hasAccessMarketBase) {
          this.$router.push({ name: 'MarketingDashboardView' })
        } else if (this.hasAccessUserBase) {
          this.$router.push({ name: 'UserRequests' })
        } else if (this.hasAccessAssetBase) {
          this.$router.push({ name: 'AssetDashboardView' })
        }
      }
    }
  },
  created() {
    document.body.classList.add('body')
  },
  mounted() {
    window.addEventListener('beforeunload', (event) => {
      if (this.$store.getters['user/isSendMailModalOpen']) {
        event.returnValue = this.$t('message.generic.discardChanges')
      }
    })
    document.addEventListener('mousedown', this.preventMethod, false)
    document.addEventListener('pointerdown', this.preventMethod, false)
    this.isCompatibleBrowser()
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      if (modalId === 'ref-message-details-modal') {
        this.setMailDetailMailObject(null)
      }
    })
    this.$root.$on('bv::modal::hide', (bvEvent) => {
      if (bvEvent.vueTarget.modalClass === 'has-confirmation-modal') {
        if (this.$store.getters['user/hasChangedModal']) {
          bvEvent.preventDefault()
          this.currentModal = bvEvent
          this.$refs.globalConfirmationModal.show()
        }
      }
    })
    this.$nextTick(function () {
      this.fabActions[0].tooltip = this.$t('message.generic.createNewObjectActionButton')
      this.fabActions[1].tooltip = this.$t('message.ticketOverview.titleModalCreate')
      this.fabActions[2].tooltip = this.$t('message.contact.newContact')
      if (typeof hasAccessMarketBase === 'boolean' && !this.hasAccessMarketBase && typeof hasAccessPropBase === 'boolean' && !this.hasAccessPropBase && typeof hasAccessAccountingBase === 'boolean' && !this.hasAccessAccountingBase && typeof hasAccessAdminBase === 'boolean' && !this.hasAccessAdminBase && typeof hasAccessUserBase === 'boolean' && !this.hasAccessUserBase && typeof hasAccessAssetBase === 'boolean' && !this.hasAccessAssetBase) {
        this.$router.push({
          name: 'OwnerSettingsView',
          query: { view: '2' }
        })
      }
    })
    this.userLoginInterval = setInterval(() => {
      this.$auth.renewTokens()
        .catch(() => {
          // For public routes we don't have to redirect to login
          if (this.$route.path === '/' || this.$route.path.startsWith('/object') || this.$route.path.startsWith('/ticket')) {
            return
          }
          // If we are not logged in we cannot renew anything. Redirect to login.
          this.$router.app.$auth.login('', {
            language: router.app.$store.getters['internationalization/getCurrentLanguage']
          })
        })
    }, 3600000)
    const contracts = localStorage && localStorage.getItem('renderId') ? JSON.parse(localStorage.getItem('renderId')) : null
    let renderId = []
    if (contracts) {
      renderId = contracts.map(x => x.renderId)
    }
    this.renderId = setInterval(() => this.getRenderStatus(), renderId.length > 0 && renderId.length < 4 ? 1000 : 3000)
  },
  beforeDestroy: function () {
    clearInterval(this.userLoginInterval)
    if (this.renderId) {
      clearInterval(this.renderId)
      localStorage.removeItem('renderId')
    }
    localStorage.removeItem('hasAccessAdminBase')
    localStorage.removeItem('hasAccessPropBase')
    localStorage.removeItem('hasAccessAssetBase')
    localStorage.removeItem('hasAccessAccountingBase')
    localStorage.removeItem('hasAccessMarketBase')
  },
  methods: {
    preventMethod(e) {
      if (e && e.srcElement && e.srcElement.nodeName !== 'TEXTAREA' && e.srcElement.nodeName !== 'SELECT' && e.srcElement.nodeName !== 'DIV' && e.srcElement.nodeName !== 'A' && e.srcElement.parentElement?.closest('table') && !e.srcElement.parentElement?.closest('#bodyMessage') && (typeof e.srcElement.className === 'string' ? !e.srcElement.className.includes('allowClickInputOnTable') : true)) {
        e.preventDefault()
        return false
      }
    },
    setFontSetting(accountId) {
      UserApi.getFontSettings(accountId)
        .then(response => {
          this.$store.dispatch('user/setFontSettings', response)
        })
        .catch(e => {
          if (!e.response || e.response.status !== 404) {
            console.log(e)
          }
        })
    },
    isCompatibleBrowser() {
      if (this.$store.getters['user/getIsCompatibleBrowser'] === null) {
        if (!this.$browserDetect.isChrome && !this.$browserDetect.isFirefox && !this.$browserDetect.isEdge) {
          this.$store.dispatch('user/setIsCompatibleBrowser', false)
          this.$refs.incompatibleBrowserModal.show()
        }
      }
    },
    closeCurrentModal() {
      this.$store.dispatch('user/setChangedModal', false).then().catch(e => console.log(e))
      this.$store.dispatch('onboarding/setIsBuildingObjectsFiltered', [])
      this.$refs.globalConfirmationModal.hide()
      this.currentModal.vueTarget.hide()
    },
    handleLoginEvent(data) {
      this.$store.dispatch('user/setAccessToken', data.accessToken)
        .catch(e => {
          console.log(e)
          Sentry.captureException(e)
        })

      this.$store.dispatch('user/changeCurrentUser', data.profile).then(() => {
        if (!localStorage.getItem('language')) {
          this.$store.dispatch('internationalization/changeCurrentLanguage', this.$store.getters['user/getLang']).then()
        } else {
          this.$store.dispatch('internationalization/changeCurrentLanguage', localStorage.getItem('language')).then()
        }
        Sentry.getCurrentScope().setUser({ id: this.accountId })
        this.setFontSetting(this.accountId)
      }).catch(e => console.log(e))
    },
    newObject() {
      this.$router.push({ name: 'ObjectCreation' })
    },
    newTicket() {
      this.$refs['add-ticket-modal'].show()
    },
    discradDraft() {
      this.$bvModal.hide('draft-writing-email-modal')
      this.$store.dispatch('user/setSendMailModalOpen', false)
      this.$refs['ref-send-mail-modal'].discradDraft = true
      this.$bvModal.hide('modal-send-mail')
      setTimeout(() => {
        this.$bvModal.show('modal-send-mail')
      }, 500)
    },
    continueEditing() {
      this.$bvModal.hide('draft-writing-email-modal')
      const modal = this.$refs['ref-send-mail-modal']
      modal.minus = false
      modal.minimized = false
      // Restore the store's draft data to match the currently editing draft,
      // so that save/discard logic uses the correct draft id (not the one from the newly opened draft)
      if (modal.isDraft && modal.draftId) {
        this.$store.commit('message/setSendMailId', modal.draftId)
        this.$store.commit('message/setSendMailIsDraft', true)
        this.$store.commit('message/setSendMailSaveAsDraft', true)
        this.$store.commit('message/setSendMailBodyHtml', modal.bodyHtml)
        this.$store.commit('message/setSubject', modal.subject)
      }
    },
    handleCloseSidebar(text) {
      if (text !== 'dropdown') {
        this.$refs['top-header']?.$refs['mobile-toggler'].toggle()
      }
      this.$refs['top-header']?.$refs['mobile-toggler'].toggle()
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
@import url('https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css');
@import '~@coreui/coreui/scss/coreui';
@import '~vue-form-wizard/dist/vue-form-wizard.min.css';
@import '~@/framework/assets/scss/custom-table.scss';
@import '~@/framework/assets/scss/base.scss';

#globalConfirmationModal___BV_modal_outer_ {
  z-index: 8002 !important;
}
.modal-header .close {
  background-image: url('~@/assets/icon_close.svg');
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
  font-size: 0;
  margin: 0 !important;
}

#blueimp-gallery .close {
  background-image: url('~@/assets/icon_close_white.svg');
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
  font-size: 0;
  margin: 0 !important;
}

.sidebar {
  -webkit-box-shadow: 1px 0 6px #666;
  -moz-box-shadow: 1px 0 6px #666;
  box-shadow: 1px 0 6px #666;
  background-color: $color-bg-white;
}

.disable-links {
  pointer-events: none;
}

main.main.main--send-mail-dock-minus > .container-fluid {
  padding-bottom: calc(4rem + env(safe-area-inset-bottom, 0px));
}

main.main.main--send-mail-dock-minimized > .container-fluid {
  padding-bottom: calc(40vh + 2rem + env(safe-area-inset-bottom, 0px));
}

.float-right {
  float: right;
}

.with-footer {
  min-height: calc(100vh - 52px);
}

// css work only on touch devices
@media (pointer: coarse) {
  body {
    overflow: hidden;
  }
  .app-body {
    display: flex;
    height: 100dvh;
    overflow: hidden;
  }
  .app-sidebar {
    overflow: hidden;
    .sidebar-nav {
      position: fixed;
      overflow-x: auto;
      overflow-y: hidden;
      height: calc(100dvh - 55px);
      .nav {
        overflow: hidden;
        max-width: 200px;
      }
    }
  }

  main.main, .app.application_form {
    overflow: auto;
    height: calc(100dvh - 55px);
    padding-bottom: calc(16px + env(safe-area-inset-bottom)) !important;
  }

}
</style>
